import * as React from 'react';
import { find } from 'lodash';
import BaseList from '../BaseList/BaseList';
import conditions from '../../data/conditions';
import insured from '../../data/insured';

class VehicleList extends BaseList {
  constructor(props) {
    super(props, {
      fields: BaseList.fields.vehicles.search,
      search: BaseList.search.vehicles,
      path: 'settings/vehicles',
      name: 'vehicles',
    });
  }

  renderHead(item) {
    return <strong>{item.registration}</strong>;
  }

  renderBody(item) {
    const condition = find(conditions, { value: parseInt(item.condition, 10) });
    const insurance = find(insured, {
      value: parseInt(item.insured ? '1' : '0', 10),
    });
    return (
      <span>
        <div className="tags is-pulled-right">
          {item.status === 'OUT' && (
            <span className={`tag is-light`}>Currently Out</span>
          )}
          {item.condition > 0 && condition !== undefined && (
            <span className={`tag is-${condition.class}`}>
              {condition.name}
            </span>
          )}
          {!item.insured && insurance !== undefined && (
            <span className={`tag is-${insurance.class}`}>Not Insured</span>
          )}
        </div>
        <br />
        {item.vehicle_type_name}
      </span>
    );
  }

  renderLeft(item) {
    return (
      <span className="avatar image is-64x64">
        <img src={item.vehicle_type_image} />
      </span>
    );
  }
}

export default VehicleList;
